import { render, staticRenderFns } from "./RecentNotifications.vue?vue&type=template&id=5790d410"
import script from "./RecentNotifications.vue?vue&type=script&lang=js"
export * from "./RecentNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports